/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EmptyCard } from '../../../components/card/Card';
import PreformattedText from '../../../components/PreformattedText';
import { ProfileThemedBasePrimaryButton } from '../../../components/buttons/Buttons';
import Spacer from '../../../components/Spacer';

interface NoExistingDataConnectionProps {
  onCreateConnection(): void;
  preferredLanguageSupported: boolean;
  isMainProfile: boolean;
  profileName: string;
}

const NoExistingDataConnection = (props: NoExistingDataConnectionProps) => {
  const { onCreateConnection, preferredLanguageSupported, isMainProfile, profileName } = props;

  return (
    <EmptyCard>
      <div className="font-headline font-color-profile">
        <FormattedMessage id="dataConnections.zero.setup.heading" />
      </div>

      <Spacer size="8">
        <PreformattedText>
          <div  className="font-subhead font-color-gsDark">
            {
              isMainProfile
              ? <FormattedMessage id="dataConnections.zero.user.setup.text.pre" />
              : <FormattedMessage id="dataConnections.zero.notUser.setup.body.pre" values={{ string1: profileName }} />
            }
          </div>
        </PreformattedText>
      </Spacer>

      <Spacer size="8" />

      <ProfileThemedBasePrimaryButton onClick={onCreateConnection} size="wide">
        <FormattedMessage id="dataConnections.zero.start.button.label" />
      </ProfileThemedBasePrimaryButton>

      {
        !preferredLanguageSupported && (
          <>
            <Spacer size="8" />
            <div className="font-caption-1 font-color-gsMedDark">
              <FormattedMessage id="dataConnections.zero.setup.onlyENSupported.message" />
            </div>
          </>
        )
      }

      <Spacer size="16" />
    </EmptyCard>
  );
};

export default NoExistingDataConnection;
